import { Link } from "react-router-dom";
import { ArrowRight, Mail, Phone, MessageCircle, Globe } from "lucide-react";
import Logo from "@/components/Logo";
import { CONTACT, NAV, SECTORS } from "@/lib/content";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-surface noise">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Link
          to="/contact"
          data-testid="footer-cta-link"
          className="group block py-20 md:py-28"
        >
          <p className="font-hud text-[11px] uppercase tracking-[0.3em] text-kinetic mb-6">
            [ NEXT MISSION ]
          </p>
          <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.04] max-w-5xl">
            LET US BUILD THE FUTURE OF{" "}
            <span className="text-kinetic">INDIAN SKIES</span> TOGETHER
          </h2>
          <p className="mt-6 flex items-center gap-3 font-hud text-xs uppercase tracking-[0.22em] text-[#9CA3AF] group-hover:text-kinetic transition-colors duration-300">
            Start the conversation
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-2" />
          </p>
        </Link>

        <div className="grid gap-12 border-t border-white/10 py-14 md:grid-cols-4">
          <div className="space-y-6">
            <Logo />
            <p className="text-sm text-[#9CA3AF] leading-relaxed max-w-xs">
              India's integrated drone company for manufacturing, services and skills.
            </p>
          </div>

          <div>
            <p className="font-hud text-[11px] uppercase tracking-[0.28em] text-[#6B7280] mb-5">
              Sitemap
            </p>
            <ul className="space-y-3">
              {[...NAV, { label: "Contact", path: "/contact" }].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    data-testid={`footer-link-${item.label.toLowerCase()}`}
                    className="text-sm text-[#9CA3AF] hover:text-kinetic transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-hud text-[11px] uppercase tracking-[0.28em] text-[#6B7280] mb-5">
              Sectors
            </p>
            <ul className="space-y-3">
              {SECTORS.map((s) => (
                <li key={s.id}>
                  <Link
                    to="/solutions"
                    className="text-sm text-[#9CA3AF] hover:text-kinetic transition-colors"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-hud text-[11px] uppercase tracking-[0.28em] text-[#6B7280] mb-5">
              Contact
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="contact-email-link"
                  className="inline-flex items-center gap-2 text-[#9CA3AF] hover:text-kinetic transition-colors"
                >
                  <Mail className="h-4 w-4 text-kinetic" /> {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.phoneHref}
                  data-testid="contact-phone-link"
                  className="inline-flex items-center gap-2 text-[#9CA3AF] hover:text-kinetic transition-colors"
                >
                  <Phone className="h-4 w-4 text-kinetic" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="contact-whatsapp-link"
                  className="inline-flex items-center gap-2 text-[#9CA3AF] hover:text-kinetic transition-colors"
                >
                  <MessageCircle className="h-4 w-4 text-kinetic" /> WhatsApp us
                </a>
              </li>
              <li>
                <span className="inline-flex items-center gap-2 text-[#9CA3AF]">
                  <Globe className="h-4 w-4 text-kinetic" /> {CONTACT.website}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-white/10 py-8">
          <p className="font-hud text-[11px] tracking-[0.2em] text-[#6B7280]" data-testid="footer-copyright">
            © {new Date().getFullYear()} AERIS INDIA TECHNOLOGY
          </p>
          <p className="font-hud text-[11px] tracking-[0.2em] text-[#6B7280]">
            ENGINEERED IN INDIA. BUILT TO SCALE.
          </p>
        </div>
      </div>
    </footer>
  );
}
